import { Directive } from "@angular/core";
import { NG_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import { onlyScriptOrImgTagValidator } from "../utils/commonUtils";

@Directive({
  selector: "[scriptorImgTagValidator]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ScriptTagValidatorDirective,
      multi: true,
    },
  ],
})
export class ScriptTagValidatorDirective implements Validator {
  validate(control: AbstractControl) {
    return onlyScriptOrImgTagValidator()(control);
  }
}
